module.exports = __webpack_public_path__ + "img/icon-device.1b82e6b9.svg";